<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Order Hub</h1>
        </div>
        <div class="float-right">
            Filter:
            <el-date-picker
                v-model="filter.date"
                type="date"
                placeholder="Filter Date"
                :picker-options="dateFilterOptions"
            >
            </el-date-picker>
        </div>
        <div class="clearfix"></div>
        <h4>Pending Orders</h4>
        <el-table
            class="mt-20"
            :data="filteredItems"
            v-loading="loading"
            :row-class-name="tableRowClassName"
        >
            <el-table-column
                prop="id"
                width="160px"
                label="Order Number"
                sortable
            >
                <template slot-scope="scope">
                    <span
                        :title="
                            isOrderDue(scope.row)
                                ? 'Order placed ' +
                                  $options.filters.relative(
                                      scope.row.created_at
                                  )
                                : ''
                        "
                        ><i
                            class="el-icon-warning"
                            v-if="isOrderDue(scope.row)"
                        ></i>
                        {{ scope.row.id }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column
                prop="tenant.name"
                label="Customer"
                sortable
            ></el-table-column>
            <el-table-column prop="created_at" label="Date" sortable>
                <template slot-scope="scope">
                    {{ scope.row.created_at | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column
                label="Status"
                prop="latest_status.status"
                sortable
            >
                <template slot-scope="scope">
                    {{
                        data_get(scope.row, "latest_status.status")
                            | capitalize_all
                    }}
                </template>
            </el-table-column>
            <el-table-column
                prop="approval_status"
                width="120px"
                label="Approval"
                sortable
            >
                <template slot-scope="scope">
                    <el-tag
                        type="success"
                        v-if="
                            scope.row.approval_status ===
                            ApprovalStatus.APPROVED
                        "
                        ><i class="el-icon-check"></i> Approved
                    </el-tag>
                    <el-tag
                        type="danger"
                        v-else-if="
                            scope.row.approval_status ===
                            ApprovalStatus.REJECTED
                        "
                        ><i class="mdi mdi-close"></i> Rejected
                    </el-tag>
                    <el-tag type="warning" v-else>Pending</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="120px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                            icon="mdi mdi-eye"
                            @click="viewItem(scope.row)"
                            >View</el-button
                        >
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as Actions from "../../store/constants/actions";
import * as ApprovalStatus from "../../constants/approval-status";

export default {
    data() {
        return {
            ApprovalStatus,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                location: {
                    street: null,
                    city: null,
                    state: null,
                    zip: null,
                },
            }),
            filter: {
                date: null,
            },
            logo_src: null,
            editingItem: null,
            loading: false,
            dateFilterOptions: {
                shortcuts: [
                    {
                        text: "Today",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        },
                    },
                    {
                        text: "Yesterday",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "A week ago",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", date);
                        },
                    },
                ],
            },
        };
    },
    computed: {
        ...mapState({
            items: (state) => state.orders,
        }),
        filteredItems() {
            let items = this.items.data;
            if (this.filter.date) {
                items = items.filter((item) => {
                    return (
                        moment
                            .utc(item.created_at)
                            .local()
                            .format("YYYYMMDD") ===
                        moment(this.filter.date).format("YYYYMMDD")
                    );
                });
            }
            return items;
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        create() {
            this.editingItem = null;
            this.dialogVisible = true;
            this.logo_src = null;
            this.form.clearFields();
        },
        getData() {
            this.loading = true;
            this.$store
                .dispatch(Actions.FETCH_ORDERS)
                .then((response) => {})
                .finally(() => (this.loading = false));
        },
        isOrderDue(item) {
            let created_at = moment.utc(item.created_at).local();
            return moment().diff(created_at, "days") >= 2;
        },
        tableRowClassName({ row, rowIndex }) {
            let created_at = moment.utc(row.created_at).local();
            if (moment().diff(created_at, "days") >= 2) {
                return "error-row";
            }
            return "";
        },
        onChangeLogo(e) {
            window.Utils.getFileImageData(e.currentTarget).then((response) => {
                this.logo_src = response;
                this.form.logo = e.target.files[0];
            });
        },
        viewItem(item) {
            this.$router.push({
                name: "ViewOrder",
                params: {
                    id: item.id,
                },
            });
        },
        editItem(item) {
            this.$router.push({
                name: "EditOrder",
                params: {
                    id: item.id,
                },
            });
        },
    },
};
</script>

<style scoped></style>
